import { ColorName } from './Colors';

export const LegacyColorMap = {
  // Brand
  zapier: `BrandOrange`,
  earth: `BrandEarth`,
  moss: `BrandMoss`,
  night: `BrandNight`,
  lavender: `BrandLavender`,
  peach: `BrandPeach`,
  bolt: `BrandBolt`,
  sky: `BrandSky`,
  cream: `BrandCream`,

  // Blue Jeans (blues)
  blue600: `UiPrimaryStrongest`,
  blue500: `UiPrimaryStronger`,
  blue400: `UiPrimary`,
  blue300: `UiPrimaryWeaker`,
  blue200: `UiPrimaryWeaker`,
  blue100: `UiPrimaryWeakest`,

  // Error
  error: `StatusErrorWeaker`,
  error500: `StatusErrorStrongest`,
  error400: `StatusErrorStronger`,
  error300: `StatusError`,
  error200: `StatusErrorWeaker`,
  error100: `StatusErrorWeakest`,

  // Warning
  warning: `StatusWarningWeaker`,
  warning500: `StatusWarningStrongest`,
  warning400: `StatusWarningStronger`,
  warning300: `StatusWarning`,
  warning200: `StatusWarningWeaker`,
  warning100: `StatusWarningWeakest`,

  // Success
  success: `StatusSuccessWeaker`,
  success500: `StatusSuccessStrongest`,
  success400: `StatusSuccessStronger`,
  success300: `StatusSuccess`,
  success200: `StatusSuccessWeaker`,
  success100: `StatusSuccessWeakest`,

  // Neutrals
  neutral800: `GrayWarm10`,
  neutral700: `GrayWarm9`,
  neutral600: `GrayWarm6`,
  neutral500: `GrayWarm5`,
  neutral400: `GrayWarm4`,
  neutral300: `GrayWarm3`,
  neutral200: `GrayWarm2`,
  neutral100: `PrimeWhite`,
  neutral100rgb: 'PrimeWhite',

  // Special colors
  black: 'PrimeBlack',
  white: 'PrimeWhite',
  transparent: 'transparent',
  inherit: 'inherit',
  currentColor: 'currentColor',

  // Accent colors
  pink: `Pink1`,
  purple: `Purple1`,

  // Aliases
  brand: 'BrandOrange',
  blueJeans: 'UiPrimaryStrongest',
  bluebell: 'UiPrimaryStronger',
  periwinkle: 'UiPrimary',
  lilac: 'UiPrimaryWeaker',
  hydrangea: 'UiPrimaryWeaker',
  acidWash: 'UiPrimaryWeakest',

  // Really old, deprecated colors
  // TODO: SET PROPER REPLACEMENTS
  blue: 'UiPrimaryStrongest',
  blue80: 'UiPrimaryStronger',
  blue60: 'UiPrimary',
  blue40: 'UiPrimaryWeaker',
  blue20: 'UiPrimaryWeaker',
  blue10: 'UiPrimaryWeakest',

  lava: 'Red4',
  lava120: 'Red4',
  lava80: 'Red4',
  lava60: 'Red3',
  lava40: 'Red3',
  lava20: 'Red2',
  lava10: 'Red2',
  lava5: 'Red1',

  ocean: 'Blue3',
  ocean120: 'Blue4',
  ocean80: 'Blue3',
  ocean60: 'Blue3',
  ocean40: 'Blue2',
  ocean20: 'Blue2',
  ocean10: 'Blue1',
  ocean5: 'Blue1',

  sun: 'Yellow2',
  sun120: 'Yellow2',
  sun80: 'Yellow2',
  sun60: 'Yellow2',
  sun40: 'Yellow2',
  sun20: 'Yellow1',
  sun10: 'Yellow1',
  sun5: 'Yellow1',

  gray: 'GrayWarm9',
  gray80: 'GrayWarm9',
  gray60: 'GrayWarm7',
  gray40: 'GrayWarm4',
  gray20: 'GrayWarm3',
  gray10: 'GrayWarm2',
  gray5: 'PrimeWhite',
} as const;

export type LegacyColorName = keyof typeof LegacyColorMap;

/** Accepts either a legacy or modern color name, and converts only legacy colors to the modern equivalent.
 *
 * Created for backwards-compatibility in UniversalLayout for code that might receive legacy colors from the BFF.
 */
export const SafeLegacyColorMap = (
  colorName: ColorName | LegacyColorName | undefined
): ColorName | undefined => {
  if (!colorName) return undefined;

  return isLegacyColor(colorName) ? LegacyColorMap[colorName] : colorName;
};

function isLegacyColor(colorName: string): colorName is LegacyColorName {
  return Object.keys(LegacyColorMap).includes(colorName);
}
